<template>
	<div class="side-pane">
		<slot />
	</div>
</template>

<script>
export default {}
</script>
